import Vue from 'vue'
import Router from 'vue-router'
import ForgotPassword from './views/ForgotPassword.vue'
import Login from './views/Login.vue'
import ResetPassword from './views/ResetPassword.vue'
import Welcome from './views/Welcome.vue'
import Overview from './views/Overview.vue'
import Checklist from './views/Checklist.vue'
import ChecklistOverview from './views/ChecklistOverview.vue'
import InspectCompact from './views/InspectCompact.vue'
import MachinesOverview from './views/MachinesOverview.vue'
import MachinesOverviewCompany from './views/MachinesOverviewCompany.vue'
import MachinesList from './views/MachinesList.vue'
import MessageFormats from './views/MessageFormats.vue'
import Glossary from './views/Glossary.vue'

import Rotorblades from './views/Rotorblades.vue'
import CheckIdOptions from './views/CheckIdOptions.vue'

import Billing from './views/Billing.vue'
import Users from './views/Users.vue'
import ChecklistImport from './views/ChecklistImport.vue'
import ChecklistTree from './views/ChecklistTree.vue'

import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  //scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'overview',
      component: Overview,
      meta: { 
        requiresAuth: true
      }
      /*
      beforeEnter (to, from, next) {
        //auth.logout()
        next('/login')
      }
      */
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '/inspect-compact',
      name: 'inspect_compact',
      component: InspectCompact
    },
    

    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },

    {
      path: '/checklists',
      name: 'checklists',
      component: ChecklistOverview,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/machines',
      name: 'machines',
      component: MachinesOverview,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/machines-company',
      name: 'machines-company',
      component: MachinesOverviewCompany,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/message-formats',
      name: 'message-formats',
      component: MessageFormats,
      meta: { 
        requiresAuth: true
      }
    },
    {
      // Die Route ist zusaetzlich am Probe-Ergebnis gegated, nicht nur der
      // Menuepunkt: sonst waere sie ueber die Adresszeile offen. Beides blendet
      // nur ein — die Durchsetzung sitzt in der Middleware des Backends.
      path: '/glossary',
      name: 'glossary',
      component: Glossary,
      meta: {
        requiresAuth: true
      },
      beforeEnter (to, from, next) {
        store.dispatch('glossary_permission').then(allowed => {
          if (allowed === true) {
            next()
            return
          }
          next('/')
        })
      }
    },
    {
      path: '/machines-list',
      name: 'machines-list',
      component: MachinesList,
      meta: { 
        requiresAuth: true
      }
    },

    
    {
      path: '/checklist/import/:uid/',
      name: 'checklist_import',
      component: ChecklistImport,
      meta: { 
        requiresAuth: true
      }
    },


    {
      path: '/checklist/:uid/:comp?/:comp2?/:comp3?/:comp4?/:comp5?/:comp6?/:task?/:question?',
      name: 'checklist',
      component: Checklist,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/checklist-tree/:uid',
      name: 'checklist_tree',
      component: ChecklistTree,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/rotorblades/:uid',
      name: 'rotorblades',
      component: Rotorblades,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/check-id-options/:uid',
      name: 'check_id_options',
      component: CheckIdOptions,
      meta: { 
        requiresAuth: true
      }
    },




    {
      path: '/billing',
      name: 'billing',
      component: Billing,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        //auth.logout()
        store.commit('logout')
        next('/')
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  //next() 
  //return
  if(to.matched.some(record => record.meta.requiresAuth)) {
    //console.log("store.getters.authStatus",  store.getters.authStatus)
    //console.log(store.state.token)
    if (store.getters.authStatus) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})


export default router